import { Box, Typography } from "@mui/material";
import DummyTable from "components/DummyViews/DummyTable";
import FormDialog from "components/ManagerModals/ViewModal";
import PaymentLogsTable from "components/Tables/paymentLogsTable";
import { useState } from "react";
import { usePaymentErrorLogs } from "services/hooks/rentals";
import ErrorDetailsForm from "./errorDetailsForm";



export default function PaymentLogs(){
    const {paymentErrorLogs, isLoadingPaymentErrorLogs} =  usePaymentErrorLogs();
    const [openDialog, setOpenDialog] = useState(false);
    const [activeItem, setActiveItem] = useState({});

    const handleClickViewDetails = (row)=>{
      setActiveItem(row);
      handleOpenDialog();
    }

    const handleOpenDialog=()=>{
      setOpenDialog(true);
    }
    const handleCloseDialog=()=>{
      setOpenDialog(false);
    }

    return (
        <Box>
            <Typography variant="h4" fontWeight="bold" sx={{ marginBottom:"10px" }}>Payment Logs</Typography>
            {isLoadingPaymentErrorLogs ? <DummyTable/> : <PaymentLogsTable tableContent={paymentErrorLogs}/>}
            <FormDialog
                title="Error Details"
                open={openDialog}
                handleClose={handleCloseDialog}
                text="Detailed description fo the error"
                content={<ErrorDetailsForm errorData={activeItem}/>}
            />
        </Box>
    )
}